export const isPlainObject = value =>
  value &&
  typeof value === 'object' &&
  (value.constructor === undefined ||
  value.constructor.name === 'Object')
